import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import api from "../services/api";

const Header = () => {
  const navigate = useNavigate();
  const { logout, activeBranch, switchBranch } = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [userRole, setUserRole] = useState("");
  const [branches, setBranches] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const switcherRef = useRef(null);

  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isSwitchUser = user?.branch_id === null || user?.branch_id === undefined;

  // Determine entity class for styling
  const entityClass = activeBranch?.branch_code === "TPE" ? "tpe" : "helios";
  const entityOptClass = (b) => b?.branch_code === "TPE" ? "tpe" : "his";

  useEffect(() => {
    setUsername(localStorage.getItem("username") || "User");
    setUserRole(user?.role || "");

    if (isSwitchUser) {
      api.get("/branches").then((res) => {
        setBranches(res.data);
        if (!activeBranch && res.data.length > 0) switchBranch(res.data[0]);
      }).catch(console.error);
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handler = (e) => {
      if (switcherRef.current && !switcherRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleLogout = () => { logout(); navigate("/login"); };

  const handleBranchSelect = (branch) => {
    switchBranch(branch);
    setDropdownOpen(false);
  };

  const displayLabel = activeBranch
    ? `${activeBranch.name}${activeBranch.branch_code ? ` (${activeBranch.branch_code})` : ""}`
    : "Select Entity";

  return (
    <nav className="main-header navbar navbar-expand navbar-white navbar-light">
      {/* Left */}
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link" data-widget="pushmenu" href="#" role="button">
            <i className="fas fa-bars"></i>
          </a>
        </li>
        <li className="nav-item d-none d-sm-inline-block">
          <Link to="/dashboard" className="nav-link">Dashboard</Link>
        </li>
      </ul>

      {/* Right */}
      <ul className="navbar-nav ml-auto align-items-center">

        {/* Entity Dropdown — for senior roles (branch_id = null) */}
        {isSwitchUser && branches.length > 0 && (
          <li className="nav-item mr-3">
            <div className="ims-entity-switcher" ref={switcherRef}>
              <button
                className={`ims-entity-btn ${entityClass}${dropdownOpen ? " open" : ""}`}
                onClick={() => setDropdownOpen(o => !o)}
              >
                <span className="ims-entity-left">
                  <span className="ims-entity-dot"></span>
                  <span>{displayLabel}</span>
                </span>
                <i className="fas fa-chevron-down ims-chevron"></i>
              </button>

              <div className={`ims-entity-menu${dropdownOpen ? " open" : ""}`}>
                {branches.map(b => {
                  const isSelected = activeBranch?.id === b.id;
                  const optClass = entityOptClass(b);
                  const label = `${b.name}${b.branch_code ? ` (${b.branch_code})` : ""}`;
                  return (
                    <div
                      key={b.id}
                      className={`ims-entity-option ${optClass}${isSelected ? " selected" : ""}`}
                      onClick={() => handleBranchSelect(b)}
                    >
                      <span className="ims-entity-opt-dot"></span>
                      <span>{b.name}</span>
                      {b.branch_code && (
                        <span className="ims-entity-opt-code">{b.branch_code}</span>
                      )}
                      {isSelected && <i className="fas fa-check ims-entity-check ms-1"></i>}
                    </div>
                  );
                })}
              </div>
            </div>
          </li>
        )}

        {/* Entity badge — for fixed users */}
        {!isSwitchUser && activeBranch && (
          <li className="nav-item mr-3">
            <span className="badge badge-primary p-2" style={{ fontSize: "12px" }}>
              <i className="fas fa-building mr-1"></i>
              {activeBranch.name}
            </span>
          </li>
        )}

        {/* User info + Logout */}
        <li className="nav-item d-flex align-items-center">
          <span className="mr-3" style={{ fontSize: "13px" }}>
            <i className="fas fa-user mr-1"></i>
            <strong>{username}</strong>
            {userRole && (
              <span className="ml-1 badge badge-light" style={{ fontSize: "10px", color: "#64748b" }}>
                {userRole}
              </span>
            )}
          </span>
          <button className="btn btn-danger btn-sm" onClick={handleLogout}>
            <i className="fas fa-sign-out-alt mr-1"></i> Logout
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
